module.exports = __webpack_public_path__ + "img/f-share-youtube.399790a5.png";